import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/axios";
import { Configuration } from "../types/Configuration";

interface ConfigurationState {
	googleApiKey: Configuration;
	message: string;
}
const initialState: ConfigurationState = {
	googleApiKey: {} as Configuration,
	message: "Loading ...",
};

const configurationSlice = createSlice({
	name: "configuration",
	initialState,
	reducers: {
		setGoogleApiKey: (state, action) => {
			state.googleApiKey = action.payload;
		},
	},
});

export const { setGoogleApiKey } = configurationSlice.actions;

export default configurationSlice.reducer;
